exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#change-captain .modal-body,#change-captain .modal-header{display:block}#change-captain button.close{display:none}#change-captain h5.modal-title{font-size:40px;text-align:center}#change-captain .btn.controls{min-width:130px;font-weight:600}", ""]);

// exports
